import { Component, HostBinding, Input, input, ChangeDetectionStrategy } from '@angular/core';
import { ComponentWithSizesComponent } from '@vendasta/galaxy/utility/component-with-sizes';

@Component({
  selector: 'glxy-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProgressBarComponent extends ComponentWithSizesComponent {
  // Progress is a number from 0-100 indicating the progress as a percentage
  @Input() progress = 0;

  // Color scheme ('primary', 'warn', 'error', 'success')
  @Input() color = 'primary';

  // Indicates that the progress data has not yet been loaded
  @Input() isLoading = false;

  // Animates the fill from 0 to `progress` on first render. Opt-in; default off preserves existing behavior.
  readonly animateOnEnter = input(false);

  @HostBinding('style.height.px')
  get padding(): number {
    switch (this.size) {
      case 'large':
        return 16;
      case 'small':
        return 8;
      default:
        return 12;
    }
  }
}
